import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { configsPageTemplate } from './configs-page-template';
import { TemplateControllerComponent } from '@streamamg/components-lib';

const routes: Routes = [
  {path: '**', component: TemplateControllerComponent, data : {pageTemplate : configsPageTemplate}},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {relativeLinkResolution: 'legacy'})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
